/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_ToolsInputs */

const en_common_header_tools = /** @type {(inputs: Common_Header_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Tools`)
};

const zh_common_header_tools = /** @type {(inputs: Common_Header_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 工具`)
};

/**
* | output |
* | --- |
* | "AI Tools" |
*
* @param {Common_Header_ToolsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_tools = /** @type {((inputs?: Common_Header_ToolsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_ToolsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_tools(inputs)
	return zh_common_header_tools(inputs)
});
export { common_header_tools as "common.header.tools" }